import React from 'react';

import { i18n } from '@lt/localization';
import { TouristDateField } from './index';

export default class TouristBirthday extends React.PureComponent {
  render() {
    const label = i18n.t('checkout.touristForm.birthdayTitle');
    return <TouristDateField {...this.props} label={label} />;
  }
}

TouristBirthday.propTypes = {};
